limitText.$inject = ["$filter"];

function limitText($filter) {
    return function (text, length) {

       if(!text)
          return "-";
       
        var limitedText = $filter('limitTo')(text, length);
       
        if(text.length > length){
            limitedText += " ..."
        }
        return limitedText; 
    }
}

module.exports = ngModule => {
    ngModule.filter('limitText', limitText);
};    